export default __webpack_public_path__ + "static/media/simulation-timer-gif-02.a5bab589.gif";